/* import __COLOCATED_TEMPLATE__ from './pull-schedules.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';
import type { PulseAccordion } from 'glint/pulse';

export interface Args {
  onContinue: () => void;
  accordion: PulseAccordion;
}

const PullSchedules = templateOnlyComponent<Args>();
export default PullSchedules;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Common::PullSchedules': typeof PullSchedules;
    'standalone/zendesk/deploy/common/pull-schedules': typeof PullSchedules;
  }
}
